"use strict";
angular.module('manageSysManagePublicMaterialLibraryRouterModule', []).
config(['$stateProvider', function($stateProvider) {
    $stateProvider.state("manageconfig.sysmanage.publicmateriallibrary.categorylibrary", { //稿件类别管理
        url: '/categorymgr?sharecategoryid&categoryname',
        views: {
            'main@manageconfig.sysmanage': {
                templateUrl: './manageConfig/sysManageMent/publicMaterialLibrary/categoryLibrary/categoryLibrary_tpl.html',
                controller: 'manageSysManageCategoryLibraryManageCtrl'
            }
        }
    });
}]);
